import React, { useRef, useEffect } from 'react';
import PropTypes, { func } from 'prop-types';
import classnames from 'classnames';
import { Field } from 'formik';
import { I18N, I18NContext } from 'commons';

export default function FormikFormControl(props) {
  const i18n = React.useContext(I18NContext);

  const isActived = useRef(false);

  const {
    labelI18nKey,
    labelText,
    labelClass,
    name,
    type,
    formValues,
    onChange,
    onBlur,
    controlClass,
    errorRender,
    error,
    touched,
    validate,
    innerRef,
    required,
    ...others
  } = props;

  const setIsActived = (val) => {
    isActived.current = val;
  };

  const doValidate = async () => {
    if (isActived.current) {
      const errorMsg = await validate(formValues);
      setIsActived(false);
      return errorMsg;
    }
    return error;
  };

  useEffect(() => {
    if (innerRef) {
      innerRef.current.setActived = setIsActived;
      innerRef.current.isActived = isActived;
    }
  }, []);

  return (
    <div className="form-group row">
      <div className="col-md-8">
        <label className={classnames('col-form-label', labelClass)} htmlFor={name} id={`${name}-label`}>

          {
            labelText || <I18N>{labelI18nKey}</I18N>
          }
          {
            required &&
            <span aria-hidden="true" className="required-star">*</span>
          }
          {
            required &&
            <span className="sr-only"><I18N>information.label.required</I18N></span>
          }
        </label>
        <Field
          className={classnames('form-control', controlClass, { valid_error: error && touched })}
          name={name}
          id={name}
          type={type}
          value={formValues[name] || ''}
          autoComplete="off"
          onChange={e => {
            if (!isActived.current) {
              setIsActived(true);
            }
            if (onChange) {
              onChange(e);
            }
          }}
          onBlur={e => {
            if (!isActived.current) {
              setIsActived(true);
            }
            if (onBlur) {
              onBlur(e);
            }
          }}
          validate={doValidate}
          innerRef={innerRef}
          aria-label={i18n[labelI18nKey]}
          aria-invalid={error && touched}
          {...((error && touched) ? { 'aria-describedby': `${name}-error` } : {})}
          {...others}
        />
      </div>
      {
        error && touched && errorRender()
      }
    </div>
  );
}

FormikFormControl.propTypes = {
  labelI18nKey: PropTypes.string,
  labelText: PropTypes.string,
  labelClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  formValues: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  controlClass: PropTypes.string,
  errorRender: PropTypes.func,
  error: PropTypes.string,
  validate: PropTypes.func,
  touched: PropTypes.bool,
  innerRef: PropTypes.objectOf(PropTypes.object)
};

FormikFormControl.defaultProps = {
  labelI18nKey: null,
  labelText: null,
  labelClass: '',
  formValues: {},
  onChange: null,
  onBlur: null,
  controlClass: '',
  errorRender: null,
  error: null,
  validate: null,
  touched: false,
  innerRef: null
};
